"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APIRoutineChangeEventsResponseSchema = exports.APIRoutineChangeEventsRequestSchema = exports.RoutineChangeMarkerSchema = void 0;
const zod_1 = require("zod");
const enums_1 = require("./enums");
/**
 * A single routine-change marker for the deep-dive chart. Structured fields
 * only — no backend-composed copy. The frontend renders the label via i18n
 * from these fields (see no-backend-user-strings rule).
 */
exports.RoutineChangeMarkerSchema = zod_1.z.object({
    // YYYY-MM-DD derived from occurredAt.
    date: zod_1.z.string(),
    eventType: zod_1.z.enum(enums_1.routineEventTypeEnum),
    changeImpact: zod_1.z.enum(enums_1.routineChangeImpactEnum).nullable(),
    // Product display name (data, not copy).
    productName: zod_1.z.string(),
    // For swaps: the previous product, when applicable.
    fromProductName: zod_1.z.string().nullish(),
    daysPerWeekBefore: zod_1.z.number().nullish(),
    daysPerWeekAfter: zod_1.z.number().nullish(),
});
exports.APIRoutineChangeEventsRequestSchema = zod_1.z.object({
    startDate: zod_1.z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    endDate: zod_1.z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
});
exports.APIRoutineChangeEventsResponseSchema = zod_1.z.array(exports.RoutineChangeMarkerSchema);
//# sourceMappingURL=routine_markers.js.map